import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const SectionWrapperStyles = css`
  display: flex;
  align-items: center;
  min-height: 900px;
  background-position: center bottom;
`
export const ContentWrapperStyles = css``
export const InfoBoxWrapperStyles = css`
  border: 1px solid ${colors.blue};
  background: radial-gradient(
    ellipse at center bottom,
    ${colors.categoriesBarGradientStart} 10%,
    ${colors.categoriesBarGradientEnd} 85%
  );
`
export const DescriptionStyles = css``
export const ButtonsStyles = css``
